var addFuelCard = (function () {

    const init = function () {
        if($('#AddRange').is(':checked')) {
            $('#range-length-group').show();
        } else {
            $('#range-length-group').hide();
        }

        $('#AddRange').on('click',
            function () {
                if($('#AddRange').is(':checked')) {
                    $('#range-length-group').show();
                } else {
                    $('#range-length-group').hide();
                }
            });

        $('#card-type-group input[type=radio]').change(function() {
            $('#card-type-group span').hide();
        });

        $(`#add-fuel-card-form input[name="submit-button"]`).click(function(e) {
            if($("#type-not-specified").is(':checked')) {
                $("#cards-has-not-type-modal").modal("show");
                e.preventDefault();
            } else {
                $("#add-fuel-card-form").submit();
            }
        });

        $(`#cards-has-not-type-submit-button`).click(function(e) {
            $("#cards-has-not-type-modal").modal("hide");
            $("#add-fuel-card-form").submit();
        });
    };

    return {
        init: init
    };

})();
